import React, { useState } from 'react';
import { FiRefreshCw } from 'react-icons/fi';
import AdminNavbar from './AdminNavbar';
import AdminSidebar from './AdminSidebar';
import CarouselManager from './decorations/CarouselManager';
import PopupManager from './decorations/PopupManager';
import ReelsManager from './decorations/ReelsManager';
import TrendingManager from './decorations/TrendingManager'; // You'll need to create this component

const AdminDecorations = () => {
  const [activeTab, setActiveTab] = useState('carousels');
  const [refreshKey, setRefreshKey] = useState(0);

  const handleRefresh = () => {
    // Force child components to refresh by changing the key
    setRefreshKey(prevKey => prevKey + 1);
    console.log("Refreshing all decoration media...");
  };

  return (
    <div className="min-h-screen bg-gray-100">
      <AdminNavbar />
      <div className="flex">
        <AdminSidebar />
        <main className="flex-1 p-6 overflow-x-hidden">
          <h1 className="text-2xl font-bold mb-6">Media Management</h1>
          
          <div className="bg-white rounded-lg shadow overflow-hidden">
            <div className="px-6 py-4 border-b border-gray-200 flex justify-between items-center">
              <h2 className="text-xl font-semibold text-gray-800">Website Media Management</h2>
              <div className="flex space-x-2">
                <button 
                  onClick={handleRefresh}
                  className="flex items-center px-3 py-2 bg-gray-100 rounded-md hover:bg-gray-200"
                >
                  <FiRefreshCw className="mr-2" /> Refresh All
                </button>
              </div>
            </div>

            <div className="px-6 py-4 border-b border-gray-200">
              <div className="flex space-x-4 overflow-x-auto pb-2">
                <button
                  onClick={() => setActiveTab('carousels')}
                  className={`px-4 py-2 rounded-md whitespace-nowrap ${activeTab === 'carousels' ? 'bg-indigo-100 text-indigo-700' : 'hover:bg-gray-100'}`}
                >
                  Carousels
                </button>
                <button
                  onClick={() => setActiveTab('popups')}
                  className={`px-4 py-2 rounded-md whitespace-nowrap ${activeTab === 'popups' ? 'bg-indigo-100 text-indigo-700' : 'hover:bg-gray-100'}`}
                >
                  Popups
                </button>
                <button
                  onClick={() => setActiveTab('reels')}
                  className={`px-4 py-2 rounded-md whitespace-nowrap ${activeTab === 'reels' ? 'bg-indigo-100 text-indigo-700' : 'hover:bg-gray-100'}`}
                >
                  Reels
                </button>
                <button
                  onClick={() => setActiveTab('trending')}
                  className={`px-4 py-2 rounded-md whitespace-nowrap ${activeTab === 'trending' ? 'bg-indigo-100 text-indigo-700' : 'hover:bg-gray-100'}`}
                >
                  Trending/Bestseller
                </button>
              </div>
            </div>

            <div className="p-6">
              {/* Each manager handles its own state and operations */}
              {activeTab === 'carousels' && (
                <CarouselManager key={`carousel-${refreshKey}`} />
              )}
              {activeTab === 'popups' && (
                <PopupManager key={`popup-${refreshKey}`} />
              )}
              {activeTab === 'reels' && (
                <ReelsManager key={`reels-${refreshKey}`} />
              )}
              {activeTab === 'trending' && (
                <TrendingManager key={`trending-${refreshKey}`} />
              )}
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default AdminDecorations;